import { AmcVisitKind } from "features/AmcVisitLogs/constants/amc-visit.constants";
import type { AmcVisit } from "features/AmcVisitLogs/types/amc-visit.types";

export function resolveVisitKind(
  visit: Pick<AmcVisit, "visitKind"> | null | undefined,
): AmcVisitKind {
  return visit?.visitKind === AmcVisitKind.EXTRA
    ? AmcVisitKind.EXTRA
    : AmcVisitKind.CONTRACT;
}

